var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getAPIMap from "../api_map.js";
import axios from "axios";
import { whatsAppTopCampaigns } from "../reports_data.js";
import { customDateStartUTCTimeZone, customDateEndUTCTimeZone, customDateStartUTCTimeZoneZ, customDateEndUTCTimeZoneZ, getTimeZoneInHours, customDateStartWithoutTz, customDateEndWitoutTz, customDateFormatStartAndEnd, } from "../utils/DateOrdinals.js";
import getIP from "../getIP.js";
const IP = getIP();
import dayjs from "dayjs";
import { tableDetails } from "constants_map.js";
const interfaceTypeMapping = {
    volumetricsPanel: "",
    smsVolumetricsPanel: "API",
    smppVolumetricsPanel: "SMPP",
    cmpgnMsgData: "WEB",
    ftpVolumetricsPanel: "FTP",
    emailVolumetricsPanel: "",
};
const waInterfaceMapping = {
    volumetricsPanel: "",
    smsVolumetricsPanel: "1",
    smppVolumetricsPanel: "3",
    cmpgnMsgData: "0",
    ftpVolumetricsPanel: "2",
};
const getPerformancePie = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var category = "";
    var channel = "";
    var direction = "";
    var convType = "";
    if (queryKey[5] === "All Channels") {
        channel = queryKey[4]
            ? queryKey[4] === "Voice"
                ? `&pr_tp=Voice`
                : queryKey[4] === "Virtual Receptionist"
                    ? `&pr_tp=VR`
                    : ""
            : "";
        direction = queryKey[4] && queryKey[4] === "WhatsApp" ? `&dir=0` : "";
    }
    else {
        category =
            queryKey[4] || queryKey[4] === 0
                ? queryKey[5] === "Virtual Receptionist" || queryKey[5] === "Voice"
                    ? `&direction=${queryKey[4]}`
                    : queryKey[6] !== "RCSPerfPie"
                        ? `&m_ctg=${queryKey[4]}`
                        : ""
                : "";
        channel = queryKey[5]
            ? queryKey[5] === "Voice"
                ? `&pr_tp=Voice`
                : queryKey[5] === "Virtual Receptionist"
                    ? `&pr_tp=VR`
                    : ""
            : "";
        direction = queryKey[5] && queryKey[5] === "WhatsApp" ? `&dir=0` : "";
        if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
            fDate = queryKey[2]
                ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
                : "";
            tDate = queryKey[3]
                ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
                : "";
        }
        if (queryKey[5] === "RCS" && queryKey[6] === "RCSPerfPie") {
            convType =
                queryKey[4] !== "" && queryKey[4] !== undefined && queryKey[4] !== null
                    ? `&m_tp=${queryKey[4]}`
                    : "";
        }
    }
    const urlMap = {
        Voice: "getVoicePerformancePie",
        "Virtual Receptionist": "getVoicePerformancePie",
        SMS: "getPerformancePie",
        WhatsApp: "getWAVolumetricsPanel",
        Email: "getEmailPerformancePie",
        RCS: "getRcsStatusTrendGraph",
    };
    // q5 contains specific channel get url of that channel
    // else (All Channel) get url from the q4
    var url = `${IP}${getAPIMap(urlMap[queryKey[5]] ? urlMap[queryKey[5]] : urlMap[queryKey[4]])}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${category}${channel}${direction}${convType}`;
    let response = yield axios.get(url, config);
    return response;
});
const getInterfacePie = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[5]
        ? queryKey[5] === "Voice"
            ? `&pr_tp=Voice`
            : queryKey[5] === "Virtual Receptionist"
                ? `&pr_tp=VR`
                : ""
        : "";
    const waOption = queryKey[5] === "WhatsApp" ? `&category=i_tp` : "";
    if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
        fDate = queryKey[2]
            ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
            : "";
        tDate = queryKey[3]
            ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
            : "";
    }
    const urlMapping = {
        Voice: "getVoiceInterfacePie",
        "Virtual Receptionist": "getVoiceInterfacePie",
        WhatsApp: "getWAVolumetricsPanel",
        SMS: "getInterfacePie",
        Email: "getInterfacePieEmail",
    };
    var url = `${IP}${getAPIMap(urlMapping[queryKey[5]])}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${channel}${waOption}`;
    let response = yield axios.get(url, config);
    return response;
});
const getSummaryPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getSummaryPanel") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWASummaryPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const tDate = queryKey[3]
        ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWAVolumetricsPanel") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllEmailVolPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getAllEmailVolPanel") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getEmailVolumetricsPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const interfaceTypeMappingEmail = {
        emailVolumetricsPanel: "",
        emailVolumetricsPanelWeb: "WEB",
        emailVolumetricsPanelApi: "API",
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const iType = interfaceTypeMappingEmail[queryKey[0]] &&
        `i_tp=${interfaceTypeMappingEmail[queryKey[0]]}`;
    var url = IP +
        getAPIMap("getVolumetricsPanelEmail") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ``}${iType ? `&${iType}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getVolumetricsPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    let iType = "";
    let channel = "";
    let category = "";
    let direction = "";
    if (queryKey[5] === "All Channels") {
        iType =
            queryKey[4] === "Voice" || queryKey[4] === "Virtual Receptionist"
                ? ""
                : interfaceTypeMapping[queryKey[0]] &&
                    `&i_tp=${interfaceTypeMapping[queryKey[0]]}`;
        channel = queryKey[4]
            ? queryKey[4] === "Voice"
                ? `&pr_tp=Voice`
                : queryKey[4] === "Virtual Receptionist"
                    ? `&pr_tp=VR`
                    : ""
            : "";
    }
    else {
        // Not all channels
        iType =
            queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                ? ""
                : interfaceTypeMapping[queryKey[0]] &&
                    `&i_tp=${interfaceTypeMapping[queryKey[0]]}`;
        channel = queryKey[5]
            ? queryKey[5] === "Voice"
                ? `&pr_tp=Voice`
                : queryKey[5] === "Virtual Receptionist"
                    ? `&pr_tp=VR`
                    : ""
            : "";
        category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    }
    if (queryKey[5] === "WhatsApp" ||
        (queryKey[5] === "All Channels" &&
            (queryKey[4] === "WhatsApp" ||
                queryKey[4] === "SMS" ||
                queryKey[4] === "Email"))) {
        fDate = queryKey[2]
            ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
            : "";
        tDate = queryKey[3]
            ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3].includes("%")
                ? queryKey[3].split("%")[0] + "Z"
                : queryKey[3])}`
            : "";
        iType =
            waInterfaceMapping[queryKey[0]] &&
                `&i_tp=${waInterfaceMapping[queryKey[0]]}`;
        direction = `&dir=0`;
    }
    const urlMap = {
        Voice: "getVoiceVolumetricsPanel",
        "Virtual Receptionist": "getVoiceVolumetricsPanel",
        SMS: "getVolumetricsPanel",
        WhatsApp: "getWAVolumetricsPanel",
        Email: "getVolumetricsPanelEmail",
    };
    var url = `${IP}${getAPIMap(urlMap[queryKey[5]]
        ? urlMap[queryKey[5]]
        : urlMap[queryKey[4]]
            ? urlMap[queryKey[4]]
            : urlMap[queryKey[6]]
                ? urlMap[queryKey[6]]
                : urlMap["SMS"])}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${category}${channel}${iType}${direction}`;
    let response = yield axios.get(url, config);
    return response;
});
const getVoiceVolumetricsPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = `${IP}${getAPIMap("getVoiceVolumetricsPanel")}${fDate && tDate ? `?${fDate}&${tDate}` : ``}`;
    let response = yield axios.get(url, config);
    return response;
});
const getApiCallsPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    // const iType =
    //   queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
    //     ? ""
    //     : interfaceTypeMapping[queryKey[0]] &&
    //       `&i_tp=${interfaceTypeMapping[queryKey[0]]}`;
    const channel = queryKey[5]
        ? queryKey[5] === "Voice"
            ? `&pr_tp=Voice&i_tp=API`
            : queryKey[5] === "Virtual Receptionist"
                ? `&pr_tp=VR`
                : ""
        : "";
    if (queryKey[5] && queryKey[5] === "WhatsApp") {
        fDate = queryKey[2]
            ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
            : "";
        tDate = queryKey[3]
            ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
            : "";
    }
    var url = `${IP}${getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
        ? "getVoiceVolumetricsPanel"
        : queryKey[5] === "WhatsApp"
            ? "getWAVolumetricsPanel"
            : "getVolumetricsPanel")}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${category}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getStatusTrendGraph = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    console.log("calling api");
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2],
            tDate: queryKey[3],
        },
    };
    if (queryKey[4] || queryKey[4] === 0) {
        if (queryKey[5] === "Virtual Receptionist") {
            config.params.direction = queryKey[4];
        }
        else {
            config.params.m_ctg = queryKey[4];
        }
    }
    if (queryKey[5]) {
        if (queryKey[5] === "Voice") {
            config.params.pr_tp = "Voice";
        }
        else if (queryKey[5] === "Virtual Receptionist") {
            config.params.pr_tp = "VR";
        }
    }
    if (queryKey[5] === "WhatsApp") {
        config.params.timeRange = "dayOfYear";
        config.params.timeZone = getTimeZoneInHours().replace("%2B", "+");
    }
    const urlMap = {
        Voice: "getVoiceStatusTrendGraph",
        "Virtual Receptionist": "getVoiceStatusTrendGraph",
        Email: "getEmailStatusTrendGraph",
        RCS: "getRcsStatusTrendGraph",
        WhatsApp: "getWaTrafficAnalysisGraph",
        SMS: "getStatusTrendGraph",
        default: "getTrafficAnalysis",
    };
    let apiUrl = "";
    if (urlMap[queryKey[5]]) {
        apiUrl = urlMap[queryKey[5]];
    }
    else {
        console.log(`[ERROR] getStatusTrendGraph: Unknown Channel: ${queryKey[5]}`);
        apiUrl = urlMap.default;
    }
    console.log("apiUrl:", apiUrl);
    const url = `${IP}${getAPIMap(apiUrl)}`;
    console.log("url:", url);
    let response = yield axios.get(url, config);
    console.log("response:", response);
    return response;
});
const getNumbersPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const capabilities = queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
        ? `&capabilities=voice`
        : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    var url = IP +
        getAPIMap("getNumbersPanel") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}${capabilities}`;
    let response = yield axios.get(url, config);
    return response;
});
const getNumberPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const tDate = queryKey[3]
        ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    const capabilities = queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
        ? `&capabilities=voice`
        : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    var url = IP +
        getAPIMap("getNumberPanel") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}${capabilities}`;
    let response = yield axios.get(url, config);
    return response;
});
const getSenderPie = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    var url = IP +
        getAPIMap("getSenderPie") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}`;
    let response = yield axios.get(url, config);
    return response;
});
const getRevenueTrendEmail = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const type = queryKey[0] === "getRevenuePieEmail"
        ? `&type=pie`
        : queryKey[0] === "getEmailRevenueTrend"
            ? "&type=trend"
            : "";
    var url = IP +
        getAPIMap("getRevenueTrendEmail") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${type}`;
    let response = yield axios.get(url, config);
    return response;
});
const getSummaryRevenue = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    const type = queryKey[0] === "revenuePie"
        ? `&type=pie`
        : queryKey[0] === "usageTrend"
            ? "&type=trend"
            : "";
    var url = IP +
        getAPIMap("getSummaryRevenue") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}${type}`;
    let response = yield axios.get(url, config);
    return response;
});
const getEmailMetrics = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `startDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `endDate=${queryKey[3]}` : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    const type = queryKey[0] === "revenuePie"
        ? `&type=pie`
        : queryKey[0] === "usageTrend"
            ? "&type=trend"
            : "";
    var url = IP +
        getAPIMap("getEmailMetrics") +
        `${startDate && endDate ? `?${startDate}&${endDate}` : ""}${category}${type}`;
    let response = yield axios.get(url, config);
    return response;
});
const getSummaryRevenueForVoice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    // const category =
    //   queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    var url = IP +
        getAPIMap("getSummaryRevenueForVoice") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getCampaignRevenueForVoice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const category = queryKey[4] === "Voice"
        ? `&pr_tp=Voice`
        : queryKey[4] === "Virtual Receptionist"
            ? `&pr_tp=VR`
            : "";
    var url = IP +
        getAPIMap("getCampaignRevenueForVoice") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${category}`;
    let response = yield axios.get(url, config);
    return response;
});
const getCampaignRevenue = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const tDate = queryKey[3]
        ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    const channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
        ? `&channel=${queryKey[4]}`
        : "";
    var url = IP +
        getAPIMap("getCampaignRevenue") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllEmailCampaignRevenue = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
        ? `&channel=${queryKey[4]}`
        : "";
    var url = IP +
        getAPIMap("getAllEmailCampaignRevenue") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getTopPackages = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[5] && queryKey[5] !== "All Channels" && queryKey[5] !== "All"
        ? `&channel=${queryKey[5]}`
        : queryKey[4]
            ? `&channel=${queryKey[4]}`
            : "";
    var url = "";
    if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
        fDate = queryKey[2]
            ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
            : "";
        tDate = queryKey[3]
            ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
            : "";
    }
    const urlMapping = {
        Voice: "getTopPackagesForVoice",
        WhatsApp: "getTopPackagesForWA",
        SMS: "getTopPackages",
        Email: "getTopPackagesForEmail",
        RCS: "getTopPackagesForRcs",
    };
    url =
        IP +
            getAPIMap(urlMapping[queryKey[5]]
                ? urlMapping[queryKey[5]]
                : urlMapping[queryKey[4]]) +
            `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    // if (queryKey[4] === "Voice") {
    //   url =
    //     IP +
    //     getAPIMap("getTopPackagesForVoice") +
    //     `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    // } else {
    //   url =
    //     IP +
    //     getAPIMap("getTopPackages") +
    //     `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    // }
    let response = yield axios.get(url, config);
    return response;
});
const getTopPackagesForVoice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
        ? `&channel=${queryKey[4]}`
        : "";
    var url = IP +
        getAPIMap("getTopPackagesForVoice") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getTopPackagesForEmail = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
        ? `&channel=${queryKey[4]}`
        : "";
    var url = IP +
        getAPIMap("getTopPackagesForEmail") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getTopEnterprises = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    let fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    let tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[5] && queryKey[5] !== "All Channels" && queryKey[5] !== "All"
        ? `&channel=${queryKey[5]}`
        : queryKey[4]
            ? `&channel=${queryKey[4]}`
            : "";
    let url = "";
    if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
        fDate = queryKey[2]
            ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
            : "";
        tDate = queryKey[3]
            ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3].split("%")[0])}`
            : "";
    }
    const urlMapping = {
        Voice: "getTopEnterprisesForVoice",
        WhatsApp: "getTopEnterprisesForWA",
        SMS: "getTopEnterprises",
        Email: "getTopEnterprisesForEmail",
        RCS: "getTopEnterprisesForRcs",
    };
    url =
        IP +
            getAPIMap(urlMapping[queryKey[5]]
                ? urlMapping[queryKey[5]]
                : urlMapping[queryKey[4]]) +
            `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getTopEnterprisesforVoice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
        ? `&channel=${queryKey[4]}`
        : "";
    var url = IP +
        getAPIMap("getTopEnterprisesForVoice") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getTopEnterprisesForEmail = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
        ? `&channel=${queryKey[4]}`
        : "";
    var url = IP +
        getAPIMap("getTopEnterprisesForEmail") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getNumberInventoryStatusPanel = () => __awaiter(void 0, void 0, void 0, function* () {
    let data = {
        revenue: "0",
        totalNumbers: "0",
        otc: "0",
        mrc: "0",
        totalInventory: "0",
        totalPurchased: "0",
    };
    return data;
});
const getNumberConfigurationPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getNumberConfigurationPanel") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getCampaignsPanel = () => __awaiter(void 0, void 0, void 0, function* () {
    let data = {
        revenue: "0",
        totalCamp: "0",
        scheduled: "0",
        completed: "0",
        inProgress: "0",
        paused: "0",
        failed: "0",
    };
    return data;
});
const getSmsCampaignPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    const tDate = queryKey[3]
        ? `enddt=${dayjs(queryKey[3])
            .subtract(1, "day")
            .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    var url = IP +
        getAPIMap("getSmsCampaignPanel") +
        `?pgsize=1&pgindex=1${fDate && tDate ? `&${fDate}&${tDate}&duration=CUSTOM&channels=sms` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getCampaignCallsPanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    const channel = queryKey[5]
        ? queryKey[5] === "Voice"
            ? `&pr_tp=Voice&i_tp=WEB`
            : queryKey[5] === "Virtual Receptionist"
                ? `&pr_tp=VR&i_tp=WEB`
                : ""
        : "";
    var url = `${IP}${getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
        ? "getVoiceVolumetricsPanel"
        : "getVolumetricsPanel")}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${category}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAccountCount = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    var _b;
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `&startDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `&endDate=${queryKey[3]}` : "";
    // const startDate = "";
    // const endDate = "";
    var url = IP +
        getAPIMap("enterprisePaginationApi") +
        `?pgsize=${10000}&pgindex=${1}${startDate}${endDate}`;
    let response = yield axios.get(url, config);
    return ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.count) || 0;
});
const getUsersCount = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    var _b;
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] || queryKey[2] === "0" ? `&startDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] || queryKey[3] === "0" ? `&endDate=${queryKey[3]}` : "";
    // const startDate = "";
    // const endDate = "";
    var url = IP +
        getAPIMap("getuser") +
        `?pgsize=${1}&pgindex=${1}${startDate}${endDate}`;
    let response = yield axios.get(url, config);
    return (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.totalUsers;
});
const getVolumetricsPanelForOutbound = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[5]
        ? queryKey[5] === "Voice"
            ? `&pr_tp=Voice&i_tp=API`
            : queryKey[5] === "Virtual Receptionist"
                ? `&pr_tp=VR&direction=outbound`
                : ""
        : "";
    var url = `${IP}${getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
        ? "getVoiceVolumetricsPanel"
        : "getVolumetricsPanel")}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getVolumetricsPanelForInbound = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const channel = queryKey[5]
        ? queryKey[5] === "Voice"
            ? `&pr_tp=Voice&i_tp=API`
            : queryKey[5] === "Virtual Receptionist"
                ? `&pr_tp=VR&direction=inbound`
                : ""
        : "";
    var url = `${IP}${getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
        ? "getVoiceVolumetricsPanel"
        : "getVolumetricsPanel")}${fDate && tDate ? `?${fDate}&${tDate}` : ``}${channel}`;
    let response = yield axios.get(url, config);
    return response;
});
const getMessageTemplatePie = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    // const startDate =
    //   queryKey[2] || queryKey[2] === "0" ? `&fromDate=${queryKey[2]}` : "";
    // const endDate =
    //   queryKey[3] || queryKey[3] === "0" ? `&toDate=${queryKey[3]}` : "";
    // var url =
    //   IP +
    //   getAPIMap("getMessageTemplatePie") +
    //   `?filterType=custom${startDate}${endDate}`;
    let url = IP + getAPIMap("getTemplates");
    let response = yield axios.get(url, config);
    return response;
});
const getEmailTemplatePie = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    // const startDate =
    //   queryKey[2] || queryKey[2] === "0" ? `&fromDate=${queryKey[2]}` : "";
    // const endDate =
    //   queryKey[3] || queryKey[3] === "0" ? `&toDate=${queryKey[3]}` : "";
    // var url =
    //   IP +
    //   getAPIMap("getEmailTemplatePie") +
    //   `?filterType=custom${startDate}${endDate}`;
    let url = IP + getAPIMap("getTemplatesEmail");
    let response = yield axios.get(url, config);
    return response;
});
const getSchedulingTypePie = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] || queryKey[2] === "0" ? `&stdt=${queryKey[2]}` : "";
    const endDate = queryKey[3] || queryKey[3] === "0" ? `&enddt=${queryKey[3]}` : "";
    const channel = queryKey[4] ? `&channels=${queryKey[4]}` : "";
    var url = IP +
        getAPIMap("getSchedulingTypePie") +
        `?pgsize=${1}&pgindex=${0}${startDate}${endDate}&duration=CUSTOM${channel}`;
    url = url.replace("{channel}", channel);
    let response = yield axios.get(url, config);
    return response;
});
const getTPSConsumption = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
    var url = IP + getAPIMap("getTPSConsumption") + `${startDate}${endDate}`;
    let response = yield axios.get(url, config);
    return response;
});
const getEmailCampaigns = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    const tDate = queryKey[3]
        ? `&enddt=${dayjs(queryKey[3])
            .subtract(1, "day")
            .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    var url = IP +
        getAPIMap("getEmailCampaigns") +
        `?${fDate && tDate ? `${fDate}${tDate}&duration=CUSTOM` : ""}&channels=email`;
    let response = yield axios.get(url, config);
    return response;
});
const getConcurrentCalls = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
    var url = IP + getAPIMap("concurrentCalls") + `${startDate}${endDate}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppCampaigns = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `stdt=${customDateStartWithoutTz(queryKey[2])}`
        : "";
    const tDate = queryKey[3]
        ? `enddt=${customDateEndWitoutTz(queryKey[3])}`
        : "";
    // const fDate = queryKey[2] ? `stdt=${queryKey[2]}` : "";
    // const tDate = queryKey[3] ? `enddt=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getWhatsAppCampaigns") +
        `?pgsize=1&pgindex=1${fDate && tDate
            ? `&${fDate}&${tDate}&duration=CUSTOM&channels=whatsapp`
            : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppCampaignMessage = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    const iType = `&i_tp=0`;
    var url = IP + getAPIMap("getWAVolumetricsPanel") + `${startDate}${endDate}${iType}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppTopCampaigns = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP + getAPIMap("getWhatsAppCampaignMessage") + `${startDate}${endDate}`;
    let response = {
        data: whatsAppTopCampaigns,
    };
    return response;
    // let response = await axios.get(url, config);
    // return response;
});
const getWhatsAppMessageType = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWAVolumetricsPanel") +
        `${startDate}${endDate}&category=dir`;
    //return response;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppTemplates = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP + getAPIMap("getWATemplates") + `${startDate}${endDate}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppRevenueData = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWhatsAppRevenueData") +
        `${startDate}${endDate}&category=m_ctg`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppTemplateTypes = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWAVolumetricsPanel") +
        `${startDate}${endDate}&category=m_ctg`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppScheduleType = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    //   const startDate = queryKey[2]
    //     ? `&fDate=${(queryKey[2])}`
    //     : "";
    //   const endDate = queryKey[3]
    //     ? `&tDate=${(queryKey[3])}`
    //     : "";
    const startDate = queryKey[2]
        ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    const endDate = queryKey[3]
        ? `enddt=${dayjs(queryKey[3])
            .subtract(1, "day")
            .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    var url = IP +
        getAPIMap("getWAScheduleType") +
        `?pgsize=${1}&pgindex=${0}&${startDate}&${endDate}&duration=CUSTOM&channels=whatsapp`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppMessageTypeTrend = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWAVolumetricsPanel") +
        `${startDate}${endDate}&category=dir&timeRange=dayOfYear`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppRevenueTrend = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    let timeZone = getTimeZoneInHours();
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWhatsAppRevenueData") +
        `${startDate}${endDate}&category=m_ctg&timeRange=dayOfYear&timeZone=${timeZone}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppStatusTrend = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    let timeZone = getTimeZoneInHours();
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWAVolumetricsPanel") +
        `${startDate}${endDate}&category=free&timeRange=dayOfYear&timeZone=${timeZone}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppTotalRevenue = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2]
        ? `?fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const endDate = queryKey[3]
        ? `&tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP + getAPIMap("getWhatsAppRevenueData") + `${startDate}${endDate}`;
    let response = yield axios.get(url, config);
    return response;
});
const getEmailScheduleType = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `&stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    const tDate = queryKey[3]
        ? `&enddt=${dayjs(queryKey[3])
            .subtract(1, "day")
            .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    var url = IP +
        getAPIMap("getEmailScheduleType") +
        `?pgsize=1&pgindex=0` +
        `${fDate && tDate ? `${fDate}${tDate}&duration=CUSTOM` : ""}&channels=email`;
    let response = yield axios.get(url, config);
    return response;
});
const getEmailRevenueTrend = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getEmailRevenueData") +
        `${startDate}${endDate}&category=dir,m_ctg&timeRange=dayofyear`;
    let response = yield axios.get(url, config);
    return response;
});
const getEmailStatusTrend = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getEMAILVolumetricsPanel") +
        `${startDate}${endDate}&category=m_ctg&timeRange=dayofyear`;
    let response = yield axios.get(url, config);
    return response;
});
const getTotalCampaignsCountForVoice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `&stdt=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `&enddt=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("totalCampaignsCountForVoice") +
        `?pgsize=1&pgindex=1&srctype=0` +
        `${fDate && tDate ? `${fDate}${tDate}&duration=CUSTOM` : ""}&channels=voice`;
    let response = yield axios.get(url, config);
    return response;
});
const getTotalCampaignsCountForVoiceForApiHits = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `&stdt=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `&enddt=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("totalCampaignsCountForVoice") +
        `?pgsize=1&pgindex=1&srctype=1` +
        `${fDate && tDate ? `${fDate}${tDate}&duration=CUSTOM` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getRevenueDataForVoice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `&fDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("revenueDataForVoice") +
        `?pgsize=1&pgindex=1&type=pie` +
        `${startDate}${endDate}`;
    let response = yield axios.get(url, config);
    return response;
});
const getRevenueTrendDataForVoice = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const startDate = queryKey[2] ? `&fDate=${queryKey[2]}` : "";
    const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
    const category = queryKey[4] || queryKey[4] === 0 ? `&m_ctg=${queryKey[4]}` : "";
    var url = IP +
        getAPIMap("revenueTrendDataForVoice") +
        `?pgsize=1&pgindex=1&type=trend` +
        `${startDate}${endDate}${category}`;
    let response = yield axios.get(url, config);
    return response;
});
const getWhatsAppInboundSummary = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `fDate=${customDateStartUTCTimeZoneZ(queryKey[2])}`
        : "";
    const tDate = queryKey[3]
        ? `tDate=${customDateEndUTCTimeZoneZ(queryKey[3])}`
        : "";
    var url = IP +
        getAPIMap("getWAVolumetricsPanel") +
        `?${fDate && tDate ? `${fDate}&${tDate}&dir=1` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllRcsCampaignRevenue = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getRcsCampaignRevenue") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllRcsTotalRevenue = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getRcsTotalRevenue") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllRcsPostbackData = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    const selectedCallOption = queryKey[4] ? `&actionType=${queryKey[4]}` : "";
    var url = IP +
        getAPIMap("getRcsPostbackData") +
        `${fDate && tDate ? `?${fDate}&${tDate}${selectedCallOption}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllRcsScheduledCampaign = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    const tDate = queryKey[3]
        ? `enddt=${dayjs(queryKey[3])
            .subtract(1, "day")
            .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    var url = IP +
        getAPIMap("getRcsScheduledCampaign") +
        `${fDate && tDate ? `?${fDate}&${tDate}&duration=CUSTOM&channels=rcs` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllRcsCampaignStatus = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    const tDate = queryKey[3]
        ? `enddt=${dayjs(queryKey[3])
            .subtract(1, "day")
            .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    var url = IP +
        getAPIMap("getRcsCampaignStatus") +
        `${fDate && tDate ? `?${fDate}&${tDate}&duration=CUSTOM&channels=rcs` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllRcsMessageType = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2]
        ? `stdt=${dayjs(queryKey[2]).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    const tDate = queryKey[3]
        ? `enddt=${dayjs(queryKey[3])
            .subtract(1, "day")
            .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
        : "";
    var url = IP +
        getAPIMap("getRcsMessageType") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAllRcsSummarypanel = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getSummarypanelForRcs") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getAgentsOverviewForRCS = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `startDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `endDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getAgentsOverviewForRCS") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
const getTemplateDistribution = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const token = queryKey[1], fromDate = queryKey[2], toDate = queryKey[3], status = queryKey[4], category = queryKey[5];
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const params = [
        fromDate && `fDate=${customDateStartUTCTimeZoneZ(fromDate)}`,
        toDate && `tDate=${customDateEndUTCTimeZoneZ(toDate)}`,
        category && `category=${category}`,
        status && `status=${status}`,
    ]
        .filter(Boolean)
        .join("&");
    const url = `${IP}${getAPIMap("getWaTemplatesList")}${params ? `?${params}` : ""}`;
    const response = yield axios.get(url, config);
    return response;
});
const getWAABusinessNumCounter = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const token = queryKey[1], fromDate = queryKey[2], toDate = queryKey[3]; //status = queryKey[4]
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const params = [
        fromDate && `fDate=${customDateStartUTCTimeZoneZ(fromDate)}`,
        toDate && `tDate=${customDateEndUTCTimeZoneZ(toDate)}`,
    ]
        .filter(Boolean)
        .join("&");
    const url = `${IP}${getAPIMap("getClients")}${params ? `?${params}` : ""}`;
    const response = yield axios.get(url, config);
    return response;
});
const getWAATemplateAnalyticsApi = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const token = queryKey[1], fromDate = queryKey[2], toDate = queryKey[3], tempId = queryKey[4]; //status = queryKey[4]
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const params = [
        fromDate && `start=${customDateStartUTCTimeZoneZ(fromDate)}`,
        toDate && `end=${customDateEndUTCTimeZoneZ(toDate)}`,
    ]
        .filter(Boolean)
        .join("&");
    const url = `${IP}${getAPIMap("getWAATemplateAnalyticsData")}${tempId}${params ? `?${params}` : ""}`;
    const response = yield axios.get(url, config);
    return response;
});
const getWhatsappTemplateList = (token, prevOptions, pgIndex, search) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const url = `${IP}${getAPIMap("getWaTemplatesList")}?pgSize=${tableDetails.pageSize}&pgIndex=${pgIndex}&status=${"approved"}${search !== "" ? `&search=${search}` : ""}`;
    // &search=${search}
    const response = yield axios.get(url, config);
    const data = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || [];
    const total = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.totalCount;
    let templatesOptions = data === null || data === void 0 ? void 0 : data.map((e) => ({
        value: e.template_id,
        label: e.template_name,
    }));
    return {
        options: templatesOptions,
        hasMore: Math.ceil(total / tableDetails.pageSize) > pgIndex, //data.length === 10,
        additional: {
            page: pgIndex + 1,
        },
    };
});
export const getEmailVolPanelData = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getEmailVolPanelData") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    let response = yield axios.get(url, config);
    return response;
});
export const getSummarySmsRevenueData = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
    };
    const fDate = queryKey[2] ? `fDate=${queryKey[2]}` : "";
    const tDate = queryKey[3] ? `tDate=${queryKey[3]}` : "";
    var url = IP +
        getAPIMap("getSummarySmsRevenueData") +
        `${fDate && tDate ? `?${fDate}&${tDate}` : ""}`;
    const response = yield axios.get(url, config);
    return response;
});
export const getAcctOverview = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
        // startDate: queryKey[2] ? queryKey[2].split("T")[0] : "",
        // endDate: queryKey[3] ? queryKey[3].split("T")[0] : "",
        },
    };
    const url = `${IP}${getAPIMap("getAcctOverview")}`;
    const response = yield axios.get(url, config);
    return response;
});
export const getMonthlyRevenue = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2] ? queryKey[2] : "",
            tDate: queryKey[3] ? queryKey[3] : "",
        },
    };
    const url = `${IP}${getAPIMap("getMonthlyRevenue")}`;
    const response = yield axios.get(url, config);
    return response;
});
export const getTrafficAnalysis = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2] ? queryKey[2] : "",
            tDate: queryKey[3] ? queryKey[3] : "",
        },
    };
    const url = `${IP}${getAPIMap("getTrafficAnalysis")}`;
    const response = yield axios.get(url, config);
    return response;
});
export const getTrafficFlowAnalysis = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2] ? queryKey[2] : "",
            tDate: queryKey[3] ? queryKey[3] : "",
        },
    };
    const url = `${IP}${getAPIMap("getTrafficFlowAnalysis")}`;
    const response = yield axios.get(url, config);
    return response;
});
export const getWaRevenueByMonth = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
            tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
            timeZone: getTimeZoneInHours().replace("%2B", "+"),
            // category: "m_ctg",
            timeRange: "dayOfYear",
        },
    };
    const url = IP + getAPIMap("getWhatsAppRevenueData");
    const response = yield axios.get(url, config);
    return response;
});
export const getSmsRevenueByMonth = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
            tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
            timeZone: getTimeZoneInHours().replace("%2B", "+"),
            type: "trend",
            timeRange: "dayOfYear",
        },
    };
    const url = IP + getAPIMap("getSummarySmsRevenueData");
    const response = yield axios.get(url, config);
    return response;
});
export const getEmailRevenueByMonth = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
            tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
            // timeZone: getTimeZoneInHours().replace("%2B", "+"),
            timeRange: "dayOfYear",
            type: "trend",
            // category: "m_ctg",
        },
    };
    const url = IP + getAPIMap("getRevenueTrendEmail");
    const response = yield axios.get(url, config);
    return response;
});
export const getRcsRevenueByMonth = (_a) => __awaiter(void 0, [_a], void 0, function* ({ queryKey }) {
    const config = {
        headers: {
            Authorization: `Bearer ${queryKey[1]}`,
        },
        params: {
            fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
            tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
            // timeZone: getTimeZoneInHours().replace("%2B", "+"),
            // type: "trend",
            // timeRange: "month",
        },
    };
    const url = IP + getAPIMap("getRcsRevenueByDays");
    const response = yield axios.get(url, config);
    return response;
});
export { getPerformancePie, getInterfacePie, getSummaryPanel, getAllEmailVolPanel, getEmailVolumetricsPanel, getVolumetricsPanel, getStatusTrendGraph, getNumbersPanel, getNumberPanel, getSenderPie, getCampaignRevenue, getAllEmailCampaignRevenue, getTopPackages, getTopEnterprises, getNumberInventoryStatusPanel, getNumberConfigurationPanel, getCampaignsPanel, getCampaignCallsPanel, getSummaryRevenue, getRevenueTrendEmail, getEmailMetrics, getAccountCount, getUsersCount, getVolumetricsPanelForOutbound, getVolumetricsPanelForInbound, getMessageTemplatePie, getEmailTemplatePie, getTopEnterprisesForEmail, getTopPackagesForEmail, getEmailScheduleType, getSchedulingTypePie, getTPSConsumption, getEmailCampaigns, getSmsCampaignPanel, getEmailRevenueTrend, getEmailStatusTrend, getWhatsAppCampaigns, getWhatsAppCampaignMessage, getWhatsAppTopCampaigns, getWhatsAppMessageType, getWhatsAppTemplates, getWhatsAppRevenueData, getWhatsAppTemplateTypes, getWhatsAppScheduleType, getSummaryRevenueForVoice, getCampaignRevenueForVoice, getTopEnterprisesforVoice, getTopPackagesForVoice, getConcurrentCalls, getWhatsAppMessageTypeTrend, getWhatsAppRevenueTrend, getWhatsAppStatusTrend, getWhatsAppTotalRevenue, getTotalCampaignsCountForVoice, getTotalCampaignsCountForVoiceForApiHits, getRevenueDataForVoice, getRevenueTrendDataForVoice, getAgentsOverviewForRCS, getApiCallsPanel, getVoiceVolumetricsPanel, getWASummaryPanel, getWhatsAppInboundSummary, getAllRcsCampaignRevenue, getAllRcsTotalRevenue, getAllRcsScheduledCampaign, getAllRcsCampaignStatus, getAllRcsMessageType, getAllRcsSummarypanel, getTemplateDistribution, getWAABusinessNumCounter, getWhatsappTemplateList, getWAATemplateAnalyticsApi, getAllRcsPostbackData, };
